/**
 * サーバのYYYYMMDDhhmmss形式からISO8601形式に変換する
 * @param {*} strDate
 * @returns
 */
export const convertServerDataToISO8601 = (dateTime, nullable = false) => {
  if (dateTime == null || dateTime === "") {
    if (nullable) {
      return "";
    }
    return new Date(Date.now()).toISOString();
  }

  const y = dateTime?.substring(0, 4);
  const m = dateTime?.substring(4, 6);
  const d = dateTime?.substring(6, 8);
  const h = dateTime?.substring(8, 10);
  const M = dateTime?.substring(10, 12);
  const s = dateTime?.substring(12, 14);
  return `${y}-${m}-${d}T${h}:${M}:${s}`;
};

export const convertServerDataToISO8601NoMin = (dateTime, nullable = false) => {
  if (dateTime == null || dateTime === "") {
    if (nullable) {
      return "";
    }
    return new Date(Date.now()).toISOString();
  }

  const y = dateTime?.substring(0, 4);
  const m = dateTime?.substring(4, 6);
  const d = dateTime?.substring(6, 8);
  const h = dateTime?.substring(8, 10);
  const M = dateTime?.substring(10, 12);
  // const s = dateTime?.substring(12, 14);
  return `${y}-${m}-${d}T${h}:${M}`;
};

export const customConvertServerDataToISO8601 = (dateTime) => {
  if (!dateTime) {
    return null;
  }

  const y = dateTime?.substring(0, 4);
  const m = dateTime?.substring(4, 6);
  const d = dateTime?.substring(6, 8);
  const h = dateTime?.substring(8, 10);
  const M = dateTime?.substring(10, 12);
  const s = dateTime?.substring(12, 14);
  return `${y}-${m}-${d}T${h}:${M}:${s}`;
};

/**
 * ISO8601形式からYYYYMMDDhhmmss形式に変換する
 * @param {*} dateTime
 */
export const convertISO8601ToServerData = (iso8601Date) => {
  const dateTime = iso8601Date.split("T");
  const d = dateTime[0].slpit("-");
  const t = dateTime[1].split(":");
  return `${d[0]}${d[1]}${d[2]}${t[0]}${t[1]}${t[2]}`;
};

/**
 * ISO8601の文字列形式からYYYYMMDDhhmmss形式に変換する
 * @param {*} dateTime
 */
export const convertISO8601StringToServerData = (iso8601Date) => {
  const dateTime = iso8601Date.split("T");
  const d = dateTime[0];
  const [year, month, day] = d.split("-");
  const t = dateTime[1];
  const [hours, minutes, seconds] = t.split(":");
  return `${year}${month}${day}${hours}${minutes}${seconds}`;
};

/**
 * YYYYMMDD形式からISO8601形式に変換する(時刻は0埋め)
 * @param {*} dateTime
 */
export const convertServerDateOnlyDayToISO0861 = (date, nullable = false) => {
  if (date == null || date === "") {
    if (nullable) {
      return "";
    }
    return new Date(Date.now()).toISOString();
  }

  const y = date?.substring(0, 4);
  const m = date?.substring(4, 6);
  const d = date?.substring(6, 8);
  return `${y}-${m}-${d}T${"00"}:${"00"}:${"00"}`;
};

/**
 * ISO8601形式からYYYYMMDD形式に変換する(時刻情報は切り落とし)
 * @param {*} dateTime
 */
export const convertISO8601ToServerDataOnlyDay = (iso8601Date) => {
  const dateTime = iso8601Date.split("T");
  const d = dateTime[0].slpit("-");
  // const t = dateTime[1].split(":");
  return `${d[0]}${d[1]}${d[2]}`;
};

/**
 * サーバのYYYYMMDDhhmmss形式から画面表示形式に変換する
 * @param {*} dateTime
 */
export const convertServerDataToDisplayDateTime = (dateTime) => {
  const y = dateTime?.substring(0, 4);
  const m = dateTime?.substring(4, 6);
  const d = dateTime?.substring(6, 8);
  const h = dateTime?.substring(8, 10);
  const M = dateTime?.substring(10, 12);
  return `${y}年${m}月${d}日 ${h}時${M}分`;
};

/**
 * サーバのYYYYMMDDhhmmss形式から画面表示形式に変換する
 * @param {*} dateTime
 */
export const convertServerDataToDisplayDate = (dateTime) => {
  const y = dateTime?.substring(0, 4);
  const m = dateTime?.substring(4, 6);
  const d = dateTime?.substring(6, 8);
  return `${y}年${m}月${d}日`;
};

/**
 * サーバのYYYYMMDDhhmmss形式から画面表示形式に変換する
 * @param {*} dateTime
 */
export const convertServerDateToDisplayTime = (dateTime) => {
  const h = dateTime?.substring(8, 10);
  const M = dateTime?.substring(10, 12);
  return `${h}時${M}分`;
};

/**
 * 作業時間の計算
 * @param {*} startDt
 * @param {*} endDt
 */
export const calculateWorkingTime = (startDt, endDt) => {
  const startDate = convert48HourServerDateToDateObj(startDt);
  const endDate = convert48HourServerDateToDateObj(endDt);
  if (!startDate || !endDate) {
    return convertServerDateToDisplayTimeline(0);
  }
  // 分単位で計算する
  startDate.setSeconds(0, 0);
  endDate.setSeconds(0, 0);
  const diffMs = endDate.getTime() - startDate.getTime();
  const totalSeconds = Math.floor(diffMs / 1000); // 小数点を切り捨てる
  return convertServerDateToDisplayTimeline(totalSeconds);
};

/**
 * 作業時間を表示形式に変換する
 * @param {*} totalSeconds
 */
export const convertServerDateToDisplayTimeline = (totalSeconds) => {
  const hours = Math.floor(totalSeconds / 3600); // 1時間 = 3600秒
  const minutes = Math.floor((totalSeconds % 3600) / 60); // 残りの秒から分を計算
  return `${hours}時間${minutes}分`;
};

/**
 * サーバのYYYYMMDDhhmmss形式からDateオブジェクトに変換する
 * @param {*} dateTime
 */
export const convertServerDateToDateObj = (dateTime) => {
  return new Date(convertServerDataToISO8601NoMin(dateTime));
};

/**
 * DateオブジェクトからYYYYMMDDhhmmss形式に変換する
 * @param {*} dateTime
 */
export const convertDateObjToServerDate = (obj, nullable = false, emptyElseNull = false) => {
  if (!obj) {
    if (nullable) {
      if (emptyElseNull) {
        return "";
      }
      return null;
    }

    obj = new Date();
  }

  return (
    obj.getFullYear().toString().padStart(4, "0") +
    (obj.getMonth() + 1).toString().padStart(2, "0") +
    obj.getDate().toString().padStart(2, "0") +
    obj.getHours().toString().padStart(2, "0") +
    obj.getMinutes().toString().padStart(2, "0") +
    obj.getSeconds().toString().padStart(2, "0")
  );
};

/**
 * DateオブジェクトからYYYYMMDD形式に変換する
 * @param {*} dateTime
 */
export const convertDateObjToServerDateOnlyDay = (obj, nullable = false) => {
  if (!obj) {
    if (nullable) {
      return null;
    }
    obj = new Date();
  }

  return (
    obj.getFullYear().toString().padStart(4, "0") +
    (obj.getMonth() + 1).toString().padStart(2, "0") +
    obj.getDate().toString().padStart(2, "0")
  );
};

/**
 * Dateオブジェクトから画面表示形式(YYYY年MM月DD日)に変換する
 * @param {*} obj
 */
export const convertDateObjToDisplayDate = (obj) => {
  return (
    obj.getFullYear().toString().padStart(4, "0") +
    "年" +
    (obj.getMonth() + 1).toString().padStart(2, "0") +
    "月" +
    obj.getDate().toString().padStart(2, "0") +
    "日"
  );
};

/**
 * 本日から一週間の
 * @param {*} baseData
 */
export const getWeekRange = (selectedDt) => {
  const startOfWeek = new Date(selectedDt);
  const dayOfWeek = startOfWeek.getDay();

  startOfWeek.setDate(startOfWeek.getDate() - dayOfWeek);
  const endOfWeek = new Date(startOfWeek);

  endOfWeek.setDate(startOfWeek.getDate() + 6);
  return {
    start: convertDateObjToDisplayDate(startOfWeek),
    end: convertDateObjToDisplayDate(endOfWeek)
  };
};

/**
 * DateオブジェクトからYYYYMMDD000000形式に変換する
 */
export const convertDateObjDefaultToday = () => {
  const obj = new Date();

  return (
    obj.getFullYear().toString().padStart(4, "0") +
    (obj.getMonth() + 1).toString().padStart(2, "0") +
    obj.getDate().toString().padStart(2, "0") +
    "000000"
  );
};

/**
 * DateオブジェクトからYYYYMMDD000000形式に変換する
 * @param {*} dateTime
 */
export const customConvertServerDataToISO8601NoHHMMSS = (dateTime) => {
  if (!dateTime) {
    return null;
  }

  const y = dateTime?.substring(0, 4);
  const m = dateTime?.substring(4, 6);
  const d = dateTime?.substring(6, 8);
  const h = "00";
  const M = "00";
  const s = "00";
  return `${y}-${m}-${d}T${h}:${M}:${s}`;
};

/**
 * DateオブジェクトからYYYYMMDD000000形式に変換する
 * @param {*} date
 */
export const convertToServerDate = (date) => {
  if (!date) {
    return null;
  }

  return (
    date.getFullYear().toString().padStart(4, "0") +
    (date.getMonth() + 1).toString().padStart(2, "0") +
    date.getDate().toString().padStart(2, "0") +
    "000000"
  );
};

export const getJapanDateTime = () => {
  const now = new Date();

  // Convert to Japan Standard Time
  const japanTime = new Date(now.toLocaleString("en-US", { timeZone: "Asia/Tokyo" }));

  // Extract components
  const year = japanTime.getFullYear();
  const month = String(japanTime.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const day = String(japanTime.getDate()).padStart(2, "0");
  const hours = String(japanTime.getHours()).padStart(2, "0");
  const minutes = String(japanTime.getMinutes()).padStart(2, "0");
  const seconds = String(japanTime.getSeconds()).padStart(2, "0");

  // Combine into the desired format
  return `${year}${month}${day}${hours}${minutes}${seconds}`;
};

// 48時間制
/**
 * サーバのYYYYMMDDhhmmss形式から48時間基準のISO8601形式に変換する
 * @param {string} dateTime サーバから取得したYYYYMMDDhhmmss形式の日付時刻文字列
 * @param {boolean} nullable 入力がnullまたは空の場合に空文字を返すか
 * @returns {string} 48時間基準で調整されたISO8601形式の文字列
 */
export const convertServerDataToISO8601_48Hours = (dateTime, nullable = false) => {
  const y = dateTime.substring(0, 4); // 年
  const m = dateTime.substring(4, 6); // 月
  const d = dateTime.substring(6, 8); // 日
  const h = parseInt(dateTime.substring(8, 10), 10); // 時
  const M = dateTime.substring(10, 12); // 分
  const s = dateTime.substring(12, 14); // 秒
  const dayAdjustment = Math.floor(h / 24); // 24時間を超える分を日数として調整
  const adjustedDate = new Date(`${y}-${m}-${d}T00:00:00Z`);
  adjustedDate.setDate(adjustedDate.getDate() + dayAdjustment);
  const adjustedY = adjustedDate.getFullYear().toString().padStart(4, "0");
  const adjustedM = (adjustedDate.getMonth() + 1).toString().padStart(2, "0");
  const adjustedD = adjustedDate.getDate().toString().padStart(2, "0");

  return `${adjustedY}-${adjustedM}-${adjustedD}T${h.toString().padStart(2, "0")}:${M}:${s}`;
};

/**
 * 48時間制のYYYYMMDDhhmmss形式を「xx時xx分」の形式に変換する。
 * @param {string} dateTime 48時間制の日付 (例: 20250122470000)
 * @returns {string} 「xx時xx分」の形式 (例: 47時00分)
 */
export const convert48DateObjTo24TimeString = (dateTime) => {
  let hour = parseInt(dateTime.substring(8, 10), 10);
  const minute = dateTime.substring(10, 12);
  return `${hour.toString().padStart(2, "0")}時${minute}分`;
};

/**
 * サーバの日付フォーマットから時間を無視したDateオブジェクトを作成
 * @param {string} dateTime - サーバから取得したYYYYMMDDhhmmss形式の日付文字列
 * @returns {Date} - 時間がリセットされたDateオブジェクト
 */
export const convertServerDateToDateObjNoTime = (dateTime) => {
  const year = parseInt(dateTime.substring(0, 4), 10);
  const month = parseInt(dateTime.substring(4, 6), 10) - 1; // JavaScriptの月は0基準
  const day = parseInt(dateTime.substring(6, 8), 10);
  const dateObj = new Date(year, month, day);
  return dateObj;
};

/**
 * サーバー形式の日付をDateオブジェクトに変換
 * @param {string} serverDate - サーバー形式 (例: 20250123031000)
 * @returns {Date} - JavaScriptのDateオブジェクト
 */
export const convert48HourServerDateToDateObj = (serverDate) => {
  if (!/^\d{14}$/.test(serverDate)) {
    console.error("Invalid server date format:", serverDate);
    return null;
  }

  const year = parseInt(serverDate.slice(0, 4), 10);
  const month = parseInt(serverDate.slice(4, 6), 10) - 1; // JavaScriptの月は0-11
  const day = parseInt(serverDate.slice(6, 8), 10);
  const hour = parseInt(serverDate.slice(8, 10), 10);
  const minute = parseInt(serverDate.slice(10, 12), 10);
  const second = parseInt(serverDate.slice(12, 14), 10);

  return new Date(year, month, day, hour, minute, second);
};

/**
 * 時間部分だけを取得する
 * @param {string} serverDate - サーバーデータ形式の日付文字列 (YYYYMMDDHHmmss)
 * @returns {string} - 時間部分のみ (HH:mm)
 */
export const extractTimeFromServerDate = (serverDate) => {
  if (!serverDate || serverDate.length < 14) return "00:00";
  const hours = serverDate.substring(8, 10);
  const minutes = serverDate.substring(10, 12);
  return `${hours}${minutes}`;
};

/**
 * 日付部分だけを取得する
 * @param {string} serverDate - サーバーデータ形式の日付文字列 (YYYYMMDDHHmmss)
 * @returns {string} - 日付部分のみ (YYYYMMDD)
 */
export const extractDateFromServerDate = (serverDate) => {
  if (!serverDate || serverDate.length < 8) {
    return "00000000";
  }
  return serverDate.slice(0, 8);
};

/**
 * 時刻フォーマット (HH:mm) を数値形式 (HHmm) に変換する
 * @param {string} time - 時刻フォーマット (例: "44:00")
 * @returns {string} - 数値形式 (例: "4400")
 */
export const convertTimeToNumeric = (time) => {
  if (!time || typeof time !== "string") return "0000";
  const [hours, minutes] = time.split(":");
  if (isNaN(hours) || isNaN(minutes)) return "0000";
  return `${parseInt(hours, 10).toString().padStart(2, "0")}${parseInt(minutes, 10).toString().padStart(2, "0")}`;
};

/**
 * 数値形式 (HHmm) を時刻フォーマット (HH:mm) に変換する
 * @param {string} numericTime - 数値形式の時刻 (例: "4400")
 * @returns {string} - 時刻フォーマット (例: "44:00")
 */
export const convertTimeToHHmm = (time) => {
  const hours = time?.slice(0, time.length - 2);
  const minutes = time?.slice(-2);
  return `${hours}:${minutes}`;
};

/**
 *時刻フォーマット (HH:mm:ss)を 数値形式 (HHmm) に変換する
 */
export const convertTimeToHHmmss = (time) => {
  if (!time || typeof time !== "string") return "0000"; // 無効な入力への対応

  const match = time.match(/^(\d{2}):(\d{2}):\d{2}$/); // 正規表現で HH:mm:ss を検証
  if (!match) return "0000"; // 無効なフォーマット

  const hours = match[1]; // 時間部分
  const minutes = match[2]; // 分部分

  return `${hours}${minutes}`;
};

export const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return date.toISOString().slice(0, 10).replace(/-/g, "");
};

/**
 * 生の日時文字列（例: "20250730110500"）を整形された日付に変換する
 * @param {string} rawDateStr - 例: "20250730110500"
 * @param {boolean} showTime - true の場合は時:分を表示し、false の場合は非表示
 * @returns {string} - "YYYY/MM/DD HH:mm" または "YYYY/MM/DD" の形式で返す
 */
export const convertDateString = (rawDateStr, showTime = true) => {
  if (!rawDateStr) return "";

  const year = rawDateStr.slice(0, 4);
  const month = rawDateStr.slice(4, 6);
  const day = rawDateStr.slice(6, 8);

  if (!showTime) {
    return `${year}/${month}/${day}`;
  }

  const hour = rawDateStr.slice(8, 10);
  const minute = rawDateStr.slice(10, 12);

  return `${year}/${month}/${day} ${hour}:${minute}`;
};
export const formatDate2 = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return convertDateObjToServerDate(date, true).slice(0, 8);
};
export const localDate = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  return `${yyyy}${mm}${dd}`;
};

/**
 * サーバー形式の日付を / 区切りの文字列に変換
 * @param {*} dateTime
 * @returns
 */
export const customConvertServerDataToSlashSeparate = (dateTime, showTime = false) => {
  if (!dateTime) {
    return null;
  }

  const y = dateTime?.substring(0, 4);
  const m = dateTime?.substring(4, 6);
  const d = dateTime?.substring(6, 8);
  const h = dateTime?.substring(8, 10);
  const M = dateTime?.substring(10, 12);
  const s = dateTime?.substring(12, 14);
  if (showTime) return `${y}/${m}/${d} ${h}:${M}`;
  return `${y}/${m}/${d}`;
};

export const customConvertServerDataToSlashSeparateWithTime = (dateTime) => {
  if (!dateTime) {
    return null;
  }

  const y = dateTime?.substring(0, 4);
  const m = dateTime?.substring(4, 6);
  const d = dateTime?.substring(6, 8);
  const h = dateTime?.substring(8, 10);
  const M = dateTime?.substring(10, 12);
  const s = dateTime?.substring(12, 14);
  return `${y}/${m}/${d} ${h}:${M}`;
}

export const getEndOfDay = (date) => {
  if (!date) return null;

  const d = new Date(date);
  d.setHours(23, 59, 59, 999);
  return d;
};

export const getYearMonth = (date) => {
  if (!date) return null;
  const year = date.slice(0, 4);
  const month = date.slice(4, 6);
  return `${year}${month}`;
};

export const getTwoMonthsBeforeLastMonthByDate = (date) => {
  if (!date) return null;
  return new Date(date.getFullYear(), date.getMonth() - 1, 0);
};

export const getSameMonthLastYearEnd = (date) => {
  if (!date) return null;
  return new Date(date.getFullYear(), date.getMonth() - 10, 0);
};

export const getSameMonthLastYear = (yyyymm) => {
  if (!yyyymm) return null;
  const str = String(yyyymm);
  if (str.length !== 6) return null;
  const year = Number(str.slice(0, 4));
  const month = Number(str.slice(4, 6));
  if (!year || !month) return null;
  const resultYear = year - 1;
  const resultMonth = String(month).padStart(2, "0");

  return Number(`${resultYear}${resultMonth}`);
};

export const convertServerDateToDisplayTimeHHmm = (dateTime) => {
  const h = dateTime?.substring(8, 10);
  const M = dateTime?.substring(10, 12);
  return `${h}:${M}`;
};